import { ThemeUIStyleObject } from "theme-ui"

export const faqItemStyle: ThemeUIStyleObject = {
  py: 6,
  px: [4, 4, 7],
  bg: "darkGreen",
  textAlign: "center",
  color: "white",
  borderRadius: "lg",
  height: "100%",
}

export const faqItemTextStyle: ThemeUIStyleObject = {
  mt: 3,
  mb: 10,
  fontFamily: "heading",
  fontSize: "paragraphMedium",
}
